import {
  AutoCompleteGeneric,
  AutoCompleteUncontrolled,
  Button,
  ISelectType,
  Modal,
} from "@4uhub/lib4uhub";
import { memo, useCallback, useState } from "react";

import AddIcon from "@mui/icons-material/Add";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ITicketAutomationMacro } from "../../../../../models/ticket-automation-macro";
import { IAddVariablesButtonProps } from "./models";

const translationPath = "components.addVariablesButton.";

export const AddVariablesButtonGeneric = memo(
  ({
    inputRef,
    options,
    onAddVariable,
    onAddCharacterLimitRequest,
  }: IAddVariablesButtonProps) => {
    const { t } = useTranslation();

    const [open, setOpen] = useState(false);

    const [variable, setVariable] = useState<ITicketAutomationMacro | null>(
      null
    );

    const openHandler = () => setOpen(true);
    const closeHandler = useCallback(() => {
      setVariable(null);
      setOpen(false);
    }, []);

    const addHandler = useCallback(() => {
      if (!variable) return;
      onAddVariable(variable.name);
      onAddCharacterLimitRequest(variable);
      closeHandler();
      setTimeout(() => {
        inputRef.current?.focus();
      }, 0);
    }, [variable, inputRef, onAddVariable, closeHandler]);

    return (
      <>
        <Modal
          open={open}
          onClose={closeHandler}
          title={`${t(translationPath + "variables")}`}
        >
          <Box pt={2}>
            <AutoCompleteGeneric<ITicketAutomationMacro>
              label={String(t(translationPath + "variable"))}
              value={variable}
              onValueSelected={setVariable}
              options={options}
              size="small"
              fullWidth
              getOptionLabel={(opt) => opt?.name ?? ""}
              isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
            />
            <Box sx={{ pt: 2, width: "100%", display: "flex", gap: 2 }}>
              <Button fullWidth variant="outlined" onClick={closeHandler}>
                {t(translationPath + "cancel")}
              </Button>
              <Button
                fullWidth
                variant="contained"
                disabled={!variable}
                onClick={addHandler}
              >
                {t(translationPath + "add")}
              </Button>
            </Box>
          </Box>
        </Modal>
        <Button
          startIcon={<AddIcon />}
          color="inherit"
          disabled={!options || options.length === 0}
          onClick={openHandler}
        >
          {t(translationPath + "add_variables")}
        </Button>
      </>
    );
  }
);
